import {IPlayer} from "data/stores/players/players.store";
import {PlayerImageType} from "data/enums";
import {
	MLB_PLAYER_AVATAR_IMAGES,
	MLB_PLAYER_SHOT_IMAGES,
	MLB_PLAYER_FULL_IMAGES,
	IMAGES_URL,
} from "data/constants";

const IMAGE_CACHE = Math.floor(Date.now() / 60000);

const getMLBOrOwnImage = (
	key: PlayerImageType,
	defaultImage: string,
	mlbLink: string,
	player: IPlayer
): Promise<string> => {
	const defaultLink = `${IMAGES_URL}image/${defaultImage}`;

	// if (player[key]) {
	// 	const link = `${IMAGES_URL}image/${String(player[key])}?_=${IMAGE_CACHE}`;
	//
	// 	return getImageOrFallback(link, defaultLink);
	// }

	const mlbLinkToImage = `${buildPlayerImageLink(mlbLink, player)}?_=${IMAGE_CACHE}`;

	return getImageOrFallback(mlbLinkToImage, defaultLink);
};

const getImageOrFallback = (path: string, fallback: string): Promise<string> => {
	return new Promise((resolve) => {
		const img = new Image();
		img.src = path;
		img.onload = () => resolve(path);
		img.onerror = () => resolve(fallback);
	});
};

const buildPlayerImageLink = (link: string, player: IPlayer) => {
	return link.replace("--player_feed_id--", `${player.feedId}`);
};

export const getPlayerAvatar = (player: IPlayer) => {
	return getMLBOrOwnImage(
		PlayerImageType.headshot,
		"player_headshot_default.png",
		MLB_PLAYER_AVATAR_IMAGES,
		player
	);
};

export const getPlayerActionShotImage = (player: IPlayer) => {
	return getMLBOrOwnImage(
		PlayerImageType.actionShotImage,
		"player_action_short_default.png",
		MLB_PLAYER_SHOT_IMAGES,
		player
	);
};

export const getPlayerActionFullImage = (player: IPlayer): Promise<string> => {
	return getMLBOrOwnImage(
		PlayerImageType.actionFullImage,
		"player_action_full_default.png",
		MLB_PLAYER_FULL_IMAGES,
		player
	);
};
